/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Product controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetProductByIdResponse, UpdateProductRequest, ProductType, GetProductsResponse, CreateProductRequest, CreateProductResponse, GetProductSelectResponse, ApplyPriceCoefficientRequest } from "../models";

@Injectable({ providedIn: "root" })
export class ProductService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getProductById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetProductByIdResponse>;
    getProductById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetProductByIdResponse>>;
    getProductById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetProductByIdResponse>>;
    getProductById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Product/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateProduct(id: number, updateProductRequest: UpdateProductRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateProduct(id: number, updateProductRequest: UpdateProductRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateProduct(id: number, updateProductRequest: UpdateProductRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateProduct(id: number, updateProductRequest: UpdateProductRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Product/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateProductRequest, requestOptions);
    }

    deleteProduct(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteProduct(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteProduct(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteProduct(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Product/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getProducts(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<GetProductsResponse>;
    getProducts(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetProductsResponse>>;
    getProducts(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetProductsResponse>>;
    getProducts(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Product`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }
        if (type != null) {
            params = HttpParamsBuilder.addToHttpParams(params, type, 'type');
        }
        if (legalEntityIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, legalEntityIds, 'legalEntityIds');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createProduct(createProductRequest: CreateProductRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateProductResponse>;
    createProduct(createProductRequest: CreateProductRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateProductResponse>>;
    createProduct(createProductRequest: CreateProductRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateProductResponse>>;
    createProduct(createProductRequest: CreateProductRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Product`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createProductRequest, requestOptions);
    }

    getProductSelect(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<GetProductSelectResponse>;
    getProductSelect(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetProductSelectResponse>>;
    getProductSelect(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetProductSelectResponse>>;
    getProductSelect(searchTerm?: string | null, type?: (Array<ProductType> | null), legalEntityIds?: (Array<number> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Product/Select`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }
        if (type != null) {
            params = HttpParamsBuilder.addToHttpParams(params, type, 'type');
        }
        if (legalEntityIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, legalEntityIds, 'legalEntityIds');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    applyPriceCoefficient(applyPriceCoefficientRequest: ApplyPriceCoefficientRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    applyPriceCoefficient(applyPriceCoefficientRequest: ApplyPriceCoefficientRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    applyPriceCoefficient(applyPriceCoefficientRequest: ApplyPriceCoefficientRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    applyPriceCoefficient(applyPriceCoefficientRequest: ApplyPriceCoefficientRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Product/apply-coefficient`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.patch(url, applyPriceCoefficientRequest, requestOptions);
    }
}
